import React from 'react';
import Cards from 'react-credit-cards';
import 'react-credit-cards/es/styles-compiled.css';
import './form.css';
import type { RouterHistory } from 'react-router';
import type {AppUser} from "../../shared/authorization";
import {compose} from "../../utility";
import withFade from "../../account/shared/animationHOC";
import {withSnackbar} from "../../shared/snackbar";
import {withAppUser} from "../../shared/authorization";
import {withRouter} from "react-router-dom";
import Cookies from "js-cookie";
import {ESIGN_ENDPOINT} from "../../configurations";
import {messages} from "../../agent-panel/sessions/constants";
import CircularProgress from "@material-ui/core/CircularProgress";
import {withStyles} from "@material-ui/core";
type Props = {
    history: RouterHistory,
    user: AppUser,
    createSnackbar: Function,
    classes: Object,
};

type State = {
    processing: boolean,
}

const styles = theme => ({
    loader: {
        color: theme.palette.primary.main,
        float: 'right',
        margin: 'auto',
    },
});
class PaymentForm extends React.Component<Props, State> {
    state = {
        cvc: '',
        expiry: '',
        focus: '',
        firstName: '',
        lastName: '',
        number: '',
        processing: false,

    };
    toggleCurrentlyProcessing = () => {
        this.setState({ processing: !this.state.processing });
    }

    handleInputFocus = (e) => {
        this.setState({ focus: e.target.name });
    }

    handleInputChange = (e) => {
        const { name, value } = e.target;

        this.setState({ [name]: value });
    }
    handlePayment = () => {
        if (this.state.processing) {
            return;
        }
        const authToken = Cookies.get('jwt');
        const data = {
            first_name: this.state.firstName,
            last_name: this.state.lastName,
            card_number: this.state.number,
            card_expiry: this.state.expiry,
            cvv2: this.state.cvc,
        };
        this.toggleCurrentlyProcessing();
        fetch(ESIGN_ENDPOINT + '/subscription', {
            method: 'PUT',
            body: JSON.stringify(data),
            headers: {
                Authorization: `JWT ${authToken}`,
            },
        })
            .then((resp) => {
                if (resp.status === 201) {
                    this.props.history.push('/payment/feedback')
                } else {
                    resp.json().then(res => {
                        this.props.createSnackbar(
                            res.message,
                            {
                                timer: 5000,
                            }
                        );
                    })
                }
                this.toggleCurrentlyProcessing();
            })
            .catch(() => {
                this.toggleCurrentlyProcessing();
                this.props.createSnackbar(messages.PAYMENT_ERROR, {
                    timer: 5000,

                });
            });
    }

    render() {
        const {
            classes,
        } = this.props;
        const firstName = this.state.firstName || '';
        const lastName = this.state.lastName || '';
        const cardName = firstName && lastName 
            ? `${firstName} ${lastName}` 
            : firstName || lastName || '';
        return (
            <div id="PaymentForm">
                <Cards
                    cvc={this.state.cvc}
                    expiry={this.state.expiry}
                    focused={this.state.focus}
                    name={cardName}
                    number={this.state.number}
                />
                <div className="form-container">
                    <div className="form__group field">
                            <input
                                className="form__field"
                                type="tel"
                                name="number"
                                placeholder="Number"
                                onChange={this.handleInputChange}
                                onFocus={this.handleInputFocus}
                            />

                    <label htmlFor="number" className="form__label">Number</label>
                    </div>
                    <div className="form__group field">

                        <input
                            className="form__field"
                                type="tel"
                                name="expiry"
                                placeholder="Expiry"
                                onChange={this.handleInputChange}
                                onFocus={this.handleInputFocus}
                            />
                        <label htmlFor="expiry" className="form__label">Expiry</label>

                    </div>
                    <div className="form__group field">


                            <input
                                className="form__field"
                                type="tel"
                                name="firstName"
                                placeholder="First name"
                                onChange={this.handleInputChange}
                                onFocus={this.handleInputFocus}
                            />
                        <label htmlFor="firstName" className="form__label">First name</label>
                    </div>
                    <div className="form__group field">


                        <input
                            className="form__field"
                            type="tel"
                            name="lastName"
                            placeholder="Last name"
                            onChange={this.handleInputChange}
                            onFocus={this.handleInputFocus}
                        />
                        <label htmlFor="lastName" className="form__label">Last name</label>
                    </div>
                    <div className="form__group field">

                            <input
                                className="form__field"
                                type="tel"
                                name="cvc"
                                placeholder="CVC"
                                onChange={this.handleInputChange}
                                onFocus={this.handleInputFocus}
                            />
                        <label htmlFor="cvc" className="form__label">CVC</label>
                    </div>
                    { !this.state.processing
                        ? (
                            <div className="button-cont" align="center">
                                <a className="form-submit-button"
                                   onClick={this.handlePayment}
                                   target="_blank"
                                   rel="nofollow noopener">
                                    Submit
                                </a>
                            </div>
                        )
                        : (
                            <div className="button-cont" align="center">

                                <CircularProgress
                                    variant="indeterminate"
                                    value={100}
                                    size={30}
                                    thickness={2}
                                    className={classes.loader}
                                />
                            </div>
                        )}

                </div>


            </div>
        );
    }
}

export default compose(
    withFade,
    withSnackbar,
    withAppUser,
    withRouter,
    withStyles(styles)
)(PaymentForm);